import * as THREE from 'three';
import { traverseUntil } from './traverseUntil';

export const getElementByRegex = (object: THREE.Object3D, regex: RegExp): THREE.Object3D | null => {
  return traverseUntil(object, (obj) => obj.visible && regex.test(obj.name));
};
